/** @jsx jsx */

import { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import { useSelector } from 'react-redux';
import { State } from 'store/store';
import { useHeader } from 'services/useHeader';

const HeaderBackground = props => {
  // const theme = useSelector((state: State) => {
  //   return state.theme;
  // });

  // const {
  //   headerStyle,
  //   headerHeight,
  //   headerBackgroundColor,
  //   headerBackgroundImage,
  //   headerBackgroundOpacity,
  //   headerOverlayColor,
  //   headerOverlayOpacity,
  //   headerTextColor,
  //   headerLogo,
  // } = theme;

  // const { headers } = useSelector((state: State) => {
  //   return state.theme;
  // });

  const { graphic } = useHeader();

  const {
    headerBackgroundColor,
    headerBackgroundImage,
    headerBackgroundOpacity,
    includeHeaderOverlay,
    headerOverlayColor,
    headerOverlayOpacity,
  } = graphic.props;

  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
      }}
    >
      <div
        css={css({
          position: 'absolute',
          width: '100%',
          height: '100%',
          background: `url('${headerBackgroundImage}') no-repeat`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          opacity: headerBackgroundOpacity * 0.01,
        })}
      />
      {includeHeaderOverlay && (
        <div
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            background: headerOverlayColor,
            opacity: headerOverlayOpacity * 0.01,
          }}
        />
      )}
    </div>
  );
};

export { HeaderBackground };
